import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import PopupPerson from "./ChatBot";
// import leaf from "../../Assets/Projects/leaf.png";
// import emotion from "../../Assets/Projects/emotion.png";
// import editor from "../../Assets/Projects/codeEditor.png";
// import chatify from "../../Assets/Projects/chatify.png";
// import suicide from "../../Assets/Projects/suicide.png";
// import bitsOfCode from "../../Assets/Projects/blog.png";


import moonflix from "../../Assets/Projects/moonflix.png";
import instagram from "../../Assets/Projects/instagram.png";
import portfolio from "../../Assets/Projects/portfolio.png";

import wallpaperpro from "../../Assets/Projects/wallpaperpro.png";
import translator from "../../Assets/Projects/translator.png";
import qrcodescanner from "../../Assets/Projects/qrcodescanner.png";
import funsoltech from "../../Assets/Projects/funsoltech.png";
import uws from "../../Assets/Projects/uws.png";
import appitact from "../../Assets/Projects/appitact.png";
import vpn from "../../Assets/Projects/vpn.png";
import dwallpapers from "../../Assets/Projects/3dwallpapers.png";
import videodownloader from "../../Assets/Projects/videodownloader.png";
import videodownloaderweb from "../../Assets/Projects/videodownloaderweb.png";

import animalringtone from "../../Assets/Projects/animalringtone.png";
import cmssite from "../../Assets/Projects/cmssite.png";
import statussaver from "../../Assets/Projects/statussaver.png";
import plugify from "../../Assets/Projects/plugify.png";




function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <PopupPerson />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p className="project-subheading">
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Chatify"
              description="Personal Chat Room or Workspace to share resources and hangout with friends build with react.js, Material-UI, and Firebase. Have features which allows user for realtime messaging, image sharing as well as supports reactions on messages."
              ghLink="https://github.com/soumyajit4419/Chatify"
              demoLink="https://chatify-49.web.app/"
            />
          </Col> */}

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={moonflix}
              isBlog={false}
              title="MOONFLIX"
              description="Movies Website build with Reactjs"
              ghLink="https://moviesfrontend.vercel.app/"
              demoLink="https://moviesfrontend.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={vpn}
              isBlog={false}
              title="SAFER INTERNET VPN"
              description="Android app with backend in Nodejs, Express & mysql"
              ghLink="https://play.google.com/store/apps/details?id=com.fast.secure.proxyvpn.unlimitedproxy.security&pli=1"
              demoLink="https://play.google.com/store/apps/details?id=com.fast.secure.proxyvpn.unlimitedproxy.security&pli=1"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={videodownloaderweb}
              isBlog={false}
              title="VIDEO DOWNLOADER WEB"
              description="Web app in Django & Postgresql"
              ghLink="https://videodownloaderapp.vercel.app/"
              demoLink="https://videodownloaderapp.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={portfolio}
              isBlog={false}
              title="PERSONAL PORTFOLIO"
              description="Personal portfolio site build with Reactjs"
              ghLink="https://portfolio-attique.vercel.app/"
              demoLink="https://portfolio-attique.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={instagram}
              isBlog={false}
              title="IG CLONE"
              description="MERN stack project with chat functionality"
              ghLink="https://instagrambackend.vercel.app/"
              demoLink="https://instagrambackend.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={wallpaperpro}
              isBlog={false}
              title="WALLPAPERPRO"
              description="Website build with html, css & JS(jquery)"
              ghLink="https://wallpaperpro.vercel.app/"
              demoLink="https://wallpaperpro.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={translator}
              isBlog={false}
              title="TRANSLATOR"
              description="Website build with html,css & javascript(jquery)"
              ghLink="https://translatorapp1.vercel.app/"
              demoLink="https://translatorapp1.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={qrcodescanner}
              isBlog={false}
              title="QR CODE GENERATOR"
              description="Website build with html,css & javascript(jquery)"
              ghLink="https://qrscannerapp.vercel.app/"
              demoLink="https://qrscannerapp.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={appitact}
              isBlog={false}
              title="APPITACT"
              description="IT services website build with ReactJs"
              ghLink="https://appitact.com/"
              demoLink="https://appitact.com/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={funsoltech}
              isBlog={false}
              title="FUNSOLTECH"
              description="IT company website build with Wordpress"
              ghLink="https://funsoltech.com/"
              demoLink="https://funsoltech.com/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={uws}
              isBlog={false}
              title="UWS"
              description="IT services website build with Wordpress"
              ghLink="https://usaworksolutions.com/"
              demoLink="https://usaworksolutions.com/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={dwallpapers}
              isBlog={false}
              title="3D WALLPAPERS"
              description="Android app with backend in NodeJS, Express & Mysql"
              ghLink="https://play.google.com/store/apps/details?id=com.wallpaperapp.hdwallpapers.livewallpaperfree.coolwallpapers"
              demoLink="https://play.google.com/store/apps/details?id=com.wallpaperapp.hdwallpapers.livewallpaperfree.coolwallpapers"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={videodownloader}
              isBlog={false}
              title="VIDEO DOWNLOADER"
              description="Android app with backend in NodeJS, Express and Mysql"
              ghLink="https://play.google.com/store/apps/details?id=com.mediastudio.allvideodownloader.downloadvideoshd.bestdownloader"
              demoLink="https://play.google.com/store/apps/details?id=com.mediastudio.allvideodownloader.downloadvideoshd.bestdownloader"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={animalringtone}
              isBlog={false}
              title="ANIMAL RINGTONE"
              description="Android app with backend in nodejs, express and mysql"
              ghLink="https://play.google.com/store/apps/details?id=com.dream_studio.animalringtones"
              demoLink="https://play.google.com/store/apps/details?id=com.dream_studio.animalringtones"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={statussaver}
              isBlog={false}
              title="SAVE STATUS"
              description="Android app with backend in NodeJS & Mysql"
              ghLink="https://play.google.com/store/apps/details?id=savestatus.images.videosaver.statusdownloadapp.storysaver"
              demoLink="https://play.google.com/store/apps/details?id=savestatus.images.videosaver.statusdownloadapp.storysaver"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cmssite}
              isBlog={false}
              title="CMSSITE"
              description="Web app with frontend in html,css & javascript & backend in php and mysql"
              ghLink="https://cmssite22.000webhostapp.com/"
              demoLink="https://cmssite22.000webhostapp.com/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={plugify}
              isBlog={false}
              title="WORDPRESS PLUGINS/EXTENSIONS"
              description="Wordpress plugins and woocommerce extensions in php"
              ghLink="https://woocommerce.com/vendor/plugify/"
              demoLink="https://woocommerce.com/vendor/plugify/"
            />
          </Col>
          {/* 
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Bits-0f-C0de"
              description="My personal blog page build with Next.js and Tailwind Css which takes the content from makdown files and renders it using Next.js. Supports dark mode and easy to write blogs using markdown."
              ghLink="https://github.com/soumyajit4419/Bits-0f-C0de"
              demoLink="https://blogs.soumya-jit.tech/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Editor.io"
              description="Online code and markdown editor build with react.js. Online Editor which supports html, css, and js code with instant view of website. Online markdown editor for building README file which supports GFM, Custom Html tags with toolbar and instant preview.Both the editor supports auto save of work using Local Storage"
              ghLink="https://github.com/soumyajit4419/Editor.io"
              demoLink="https://editor.soumya-jit.tech/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Plant AI"
              description="Used the plant disease dataset from Kaggle and trained a image classifer model using 'PyTorch' framework using CNN and Transfer Learning with 38 classes of various plant leaves. The model was successfully able to detect diseased and healthy leaves of 14 unique plants. I was able to achieve an accuracy of 98% by using Resnet34 pretrained model."
              ghLink="https://github.com/soumyajit4419/Plant_AI"
              demoLink="https://plant49-ai.herokuapp.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Ai For Social Good"
              description="Using 'Natural Launguage Processing' for the detection of suicide-related posts and user's suicide ideation in cyberspace  and thus helping in sucide prevention."
              ghLink="https://github.com/soumyajit4419/AI_For_Social_Good"
            // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley" <--------Please include a demo link here
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Face Recognition and Emotion Detection"
              description="Trained a CNN classifier using 'FER-2013 dataset' with Keras and tensorflow backened. The classifier sucessfully predicted the various types of emotions of human. And the highest accuracy obtained with the model was 60.1%.
              Then used Open-CV to detect the face in an image and then pass the face to the classifer to predict the emotion of a person."
              ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
            // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here 
            />
          </Col> */}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
